/**
 * Header search bar
 */

import $ from 'jquery';

import { close as closeNav } from './navigation';

// Cached elements
const $el = {
	button: $('.js-search-bar-toggle'),
	searchBar: $('.c-search-bar')
};

const _vars = {
	isOpen: false
};

// Module events
export default function init() {
	bindEvents();
}

// User interactions go here
function bindEvents() {
	$el.button.on('click', () => {
		if (_vars.isOpen) {
			close();
		} else {
			open();
			closeNav();
		}
	});
	
	// Close it if user clicks away
	$(document).on('click', (event) => {
		if (!$(event.target).closest('.c-top-bar__utils').length) {
			close();
		}
	});
	
	// Close it if user needs to see mega menu
	// $('.c-nav .has-subnav').hover(() => {
	// 	close();
	// });
}

function open() {
	$el.searchBar.addClass('is-active');
	$el.button.addClass('is-active');
	_vars.isOpen = true;
}

export function close() {
	$el.searchBar.removeClass('is-active');
	$el.button.removeClass('is-active');
	_vars.isOpen = false;
}
